import { render, staticRenderFns } from "./collectPerson.vue?vue&type=template&id=f6b3752a&scoped=true"
import script from "./collectPerson.vue?vue&type=script&lang=js"
export * from "./collectPerson.vue?vue&type=script&lang=js"
import style0 from "./collectPerson.vue?vue&type=style&index=0&id=f6b3752a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b3752a",
  null
  
)

export default component.exports